import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;
export type FilterGroup = 'cat' | 'spec' | 'driver' | 'time';

export interface FilterPanelOptions {
  usageTypes: any[];
  vehicleGroups: any[];
  vehicleTypes: any[];
  vehicleBrands: any[];
  trackerTypes: any[];
  serviceAreas: any[];
  plateTypes: any[];
}

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.css'],
})

export class FilterPanelComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() open = true;
  @Input() options: FilterPanelOptions = {
    usageTypes: [],
    vehicleGroups: [],
    vehicleTypes: [],
    vehicleBrands: [],
    trackerTypes: [],
    serviceAreas: [],
    plateTypes: [],
  };
  @Input() groupCounts: Record<FilterGroup, number> = {
    cat: 0,
    spec: 0,
    driver: 0,
    time: 0,
  };
  @Input() appliedValue: any = null;

  @Output() apply = new EventEmitter<any>();
  @Output() closed = new EventEmitter<void>();

  groupsOpen: Record<FilterGroup, boolean> = {
    cat: true,
    spec: false,
    driver: false,
    time: false,
  };

  private lastApplied: any = null;

  filterForm: FormGroup;

  constructor(
    private el: ElementRef,
    private fb: FormBuilder,
    private gurdService: GurdServiceService,
  ) {
    this.filterForm = this.fb.group(this.filterDefaults());
  }

  ngOnInit(): void {
    this.lastApplied = { ...this.filterForm.value };
  }

  ngAfterViewInit(): void {
    this.initTimePickers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appliedValue']?.currentValue) {
      this.lastApplied = { ...changes['appliedValue'].currentValue };
    }
  }

  toggleGroup(key: FilterGroup): void {
    this.groupsOpen[key] = !this.groupsOpen[key];
  }

  submitApply(): void {
    this.syncTimeFromDom();
    this.apply.emit({ ...this.filterForm.value });
  }

  submitReset(): void {
    this.filterForm.reset(this.filterDefaults());
    this.clearTimeDom();
    this.apply.emit({ ...this.filterForm.value });
  }

  requestClose(): void {
    this.revertToLastApplied();
    this.closed.emit();
  }

  private filterDefaults(): { [key: string]: any } {
    return {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      strUnitID: '',
      tiMobileType: -1,
      iMobileDomain: -1,
      tiGPSType: -1,
      strFullName: '',
      strCellNo: '',
      strMobile: '',
      iCode: -1,
      iGPS: -1,
      strVehicleNo: '',
      strPersonnelID: '',
      iSKm: '',
      iEKm: '',
      iSYearConstruction: '',
      iEYearConstruction: '',
      strSTime: '',
      strETime: '',
      tiFuelType: '-1',
      tiPassenger: '',
      strVehicleType: '',
      tiMobileUsage: '-1',
      tiPlateType: '-1',
      tiMobileGroup: '-1',
    };
  }

  private revertToLastApplied(): void {
    if (!this.lastApplied) return;
    this.filterForm.patchValue(this.lastApplied);
    $('#strSTime').val(this.lastApplied.strSTime ?? '');
    $('#strETime').val(this.lastApplied.strETime ?? '');
  }

  private syncTimeFromDom(): void {
    this.filterForm.get('strSTime')?.setValue($('#strSTime').val());
    this.filterForm.get('strETime')?.setValue($('#strETime').val());
  }

  private clearTimeDom(): void {
    $('#strSTime').val('');
    $('#strETime').val('');
  }

  private autoFlipClockpicker(host: any): void {
    const inst: any = $(host).data('clockpicker');
    if (!inst || !inst.isShown || !inst.popover) return;

    const $host = $(host);
    const offset = $host.offset();
    if (!offset) return;

    const popH = inst.popover.outerHeight() || 0;
    if (!popH) return;

    const elTop = offset.top;
    const elH = $host.outerHeight() || 0;
    const viewTop = $(window).scrollTop() || 0;
    const viewH = $(window).height() || 0;
    const margin = 12;
    const spaceBelow = viewTop + viewH - (elTop + elH);
    const spaceAbove = elTop - viewTop;

    let placement: string = inst.options.placement || 'bottom';
    if (
      placement === 'bottom' &&
      spaceBelow < popH + margin &&
      spaceAbove >= popH + margin
    ) {
      placement = 'top';
    } else if (
      placement === 'top' &&
      spaceAbove < popH + margin &&
      spaceBelow >= popH + margin
    ) {
      placement = 'bottom';
    }

    if (placement !== inst.options.placement) {
      inst.options.placement = placement;
      inst.popover.removeClass('top bottom left right').addClass(placement);
    }
    inst.locate();
  }

  private initTimePickers(): void {
    $(this.el.nativeElement)
      .find('.clockpicker')
      .each((_: any, host: any) => {
        $(host).clockpicker({
          donetext: 'top',
          align: 'top',
          autoclose: true,
          afterShow: () => this.autoFlipClockpicker(host),
        });
      });
  }
  
}
